<script lang="typescript">
  import { afterUpdate, createEventDispatcher } from 'svelte'

  export let row: number = 0
  export let value: string = ''
  export let leftSpace: number = 0
  export let rightSpace: number = 0
  export let focus: boolean = false
  export let readonly: boolean = false
  export let score: number = 0

  let hadFocus: boolean // init as undefined
  let rowElement: HTMLElement
  let scoreElement: HTMLElement

  const dispatch = createEventDispatcher()

  afterUpdate(() => {
    if (focus && !hadFocus) {
      const input = rowElement.querySelector('input')
      if (input) {
        input.focus()
      }
    }
    hadFocus = focus
  })

  // Moves to the next letter (if not at the end).
  function goToNextChar(event: KeyboardEvent) {
    const nextTableCell = (event.target as HTMLInputElement).parentElement.nextElementSibling
    const inputElement = nextTableCell && nextTableCell.querySelector('input')
    if (inputElement) {
      inputElement.focus()
    }
  }

  function handleKey(event: KeyboardEvent) {
    // Ignore if the field is readonly.
    if (readonly) { return }

    // If a letter, set the value of the input field.
    if (/^[a-z]$/i.test(event.key)) {
      let inputElement = event.target as HTMLInputElement
      inputElement.value = event.key
      const col = parseInt(inputElement.name.match(/r\d+c(\d+)/)[1], 10)
      value = value.slice(0, col) + inputElement.value + value.slice(col + 1)
      goToNextChar(event)
    }

    // If Enter is pressed, submit the row's word as a guess.
    if (/^Enter$/i.test(event.key)) {
      dispatch('submitWord', {
        guess: value,
        offset: leftSpace,
        scoreElement
      })
    }
  }
</script>

<tr bind:this={rowElement}>
  {#each new Array(leftSpace) as _}
    <td></td>
  {/each}
  {#each value as char, i}
    <td><input name={`r${row}c${i}`} value={char} maxlength={1} size={1} on:keypress={handleKey} disabled={readonly} pattern="[A-Za-z]"/></td>
  {/each}
  {#each new Array(rightSpace) as _}
    <td></td>
  {/each}
  <td class="score" bind:this={scoreElement}>
    {#if score > 0}
      {score}
    {/if}
  </td>
</tr>

<style>
  input {
    text-transform: uppercase;
  }
  .score {
    text-align: right;
  }
</style>
